<template>
    <div class="part-panel">
        <div class="mt-2 mb-2">
            <a href="#" v-on:click.prevent="goToSearch">Return to Search</a>
        </div>
        <div class="d-flex mb-2" v-show="currentPanel != 'wait'">
            <div class="part-header-panel d-flex flex-grow-1 ul-red-panel ul-wide-border-panel">
                <div class="d-flex flex-column align-items-center justify-content-center pl-2 pr-2">
                    <img class="part-image" v-bind:src="partImageSrc(partContent.part_image_url)">
                    <a class="part-image-credit" target="_blank" rel="nofollow" v-bind:href="partContent.part_image_credit_url">{{partContent.part_image_credit_name}}</a>
                </div>

                <div class="d-flex flex-column justify-content-center flex-grow-1 pl-2 pr-2">
                    <div class="d-flex justify-content-between align-items-baseline">
                        <h1 class="d-flex flex-column part-detail-mfr-header">
                            <span>{{partContent.manufacturer}}</span>
                            <span class="font-weight-bold">{{partContent.part_number}}</span>
                        </h1>
                    </div>
                    <div class="part-detail-description" v-bind:title="partContent.description">{{partContent.description}}</div>
                </div>
            </div>
        </div>
        <div class="tab-content ul-red-panel ul-wide-border-panel ul-light-background mb-3" v-show="currentPanel == 'preview' || currentPanel == 'export'">
            <div v-show="currentPanel == 'preview'">
                <PreviewPanel v-bind:previewData="previewContent" :requestPrompt="false"></PreviewPanel>
                <div class="d-flex flex-column align-items-center justify-content-center mt-2 mb-2">
                    <a v-if="exportContent != null" class="btn btn-dark" href="#" v-on:click.prevent="changePanel('export')">Download Now</a>
                </div>
            </div>
            <div v-if="exportContent != null" class="export-panel p-2" v-show="currentPanel == 'export'">
                <a class="small back-link" href="#" v-on:click.prevent="changePanel('preview')">Back to Preview</a>
                <ExportPanel v-bind:exportData="exportContent" v-bind:userContent="userContent"></ExportPanel>
            </div>
        </div>
        <div class="tab-content ul-red-panel ul-wide-border-panel mb-3" v-show="currentPanel == 'wait' || currentPanel == 'download' || currentPanel == 'export_error' || currentPanel == 'part_error'">
            <div class="wait-panel hide-flex flex-column align-items-center justify-content-center mt-2" v-show="currentPanel == 'wait'">
                <img class="export-image" src="../assets/images/placeholders/UL-Loading-4B.gif" />
                <h2 class="mb-3">Starting Your Download</h2>
                <div>
                    Manufacturer:
                    {{partContent.manufacturer}}
                </div>
                <div class="mb-3">
                    Manufacturer PN:
                    {{partContent.part_number}}
                </div>
            </div>
            <div class="download-panel hide-flex flex-column align-items-center justify-content-center mt-2" v-show="currentPanel == 'download'">
                <img class="export-image" src="../assets/images/placeholders/UL-Loading-Done.gif" />
                <h2 class="mb-3">Download Complete</h2>
                <div>
                    Manufacturer:
                    {{partContent.manufacturer}}
                </div>
                <div class="mb-3">
                    Manufacturer PN:
                    {{partContent.part_number}}
                </div>
                <div class="d-flex flex-column align-items-center justify-content-center mt-2 mb-2">
                    <a class="small back-link" href="#" v-on:click.prevent="changePanel('preview')">Back to Preview</a>
                </div>
            </div>
            <div class="export-error-panel hide-flex flex-column align-items-center justify-content-center mt-2" v-show="currentPanel == 'export_error'">
                <img class="export-image" src="../assets/images/placeholders/UL-Loading-Done.gif" />
                <h2 class="mb-3">Download Failure</h2>
                <div>
                    Manufacturer:
                    {{partContent.manufacturer}}
                </div>
                <div class="mb-3">
                    Manufacturer PN:
                    {{partContent.part_number}}
                </div>
                <div class="d-flex flex-column align-items-center justify-content-center mt-2 mb-2">
                    <a class="small back-link" href="#" v-on:click.prevent="changePanel('preview')">Back to Preview</a>
                </div>
            </div>
            <div class="part-error-panel hide-flex flex-column align-items-center justify-content-center mt-2" v-show="currentPanel == 'part_error'">
                <h2 class="mb-3">Part Not Available</h2>
                <div>
                    Manufacturer:
                    {{partContent.manufacturer}}
                </div>
                <div class="mb-3">
                    Manufacturer PN:
                    {{partContent.part_number}}
                </div>
                <div class="d-flex flex-column align-items-center justify-content-center mb-2">
                    <a class="small back-link" href="#" v-on:click.prevent="changePanel('preview')">Back to Preview</a>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import PreviewPanel from "./PreviewPanel.vue";
    import ExportPanel from "./ExportPanel.vue";

    export default {
        name: "PartPanel",
        components: {
            PreviewPanel,
            ExportPanel
        },
        data() {
            return {
                currentPanel: "preview",
            }
        },                
        props: {
            previewContent: {
                type: Object,
                default: () => {
                    return {
                        threed_content: {
                            has_3d: false,
                            part_unique_id: "",
                            url: ""
                        },
                        symbol_preview: {},
                        footprint_preview: {}
                    }
                }
            },
            exportContent: {
                type: Object,
                default: () => {
                    return {
                        exportGroups: []
                    }
                }
            },
            partContent: {
                type: Object,
                default: () => {
                    return {
                        manufacturer: "",
                        partNumber: ""
                    }
                }
            },
            userContent: {
                type: Object,
                default: () => {
                    return {
                        loggedin: false,
                        username: ""
                    }
                }
            }
        },
        methods: {
            goToSearch() {
                this.$root.$emit('change_panel', 'search');
            },
            changePanel(panel) {
                this.currentPanel = panel;
            },
            partImageSrc(imgSrc) {
                if (imgSrc != undefined && imgSrc != null && imgSrc != '')
                    return imgSrc;
                return require('../assets/images/placeholders/Image-Unavailable.png');
            }
        },
        mounted() {

            this.$root.$on('select_part', () => {
                this.changePanel('preview');
            });

            this.$root.$on('export_part', () => {
                this.changePanel('wait');
            });

            this.$root.$on('export_download', () => {
                this.changePanel('download');
            });

            this.$root.$on('part_error', () => {
                this.changePanel('part_error');
            });

            this.$root.$on('export_error', () => {
                this.changePanel('export_error');
            });

            this.$root.$on('export_timeout', () => {
                this.changePanel('export_error');
            });
        }
    }
</script>

<style scoped>
    .part-detail-mfr-header {
        font-size: 16px;
    }

    .part-header-panel{
        max-width: 540px;
    }

    .part-detail-header {
        height: 90px;
    }

    .part-detail-description {
        max-width: 430px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 80%;
    }

    .hide-flex {
        display: -ms-flexbox;
        display: -webkit-box;
        display: flex;
    }


    @media (max-width: 1299.9px) {
        .part-header-panel {
            max-width: 450px;
        }

        .part-detail-description {
            max-width: 330px;
        }
    }

    @media (max-width: 434.9px) {
        .part-header-panel {
            max-width: 400px;
        }

        .part-detail-description {
            max-width: 280px;
        }
    }
</style>